<template>
  <div>
    <v-card
      class="mx-auto mb-5 d-flex justify-end align-center"
      width="100%"
      :max-width="maxWidth"
      tile
      flat
      color="transparent"
    >
      {{ localStorage.translations.pages['statistic_employee'].tables['primechanie'] + ':' }}
      <BaseInput type="switch" v-model="showNotes.value" class="ml-4" @input="changeNotes"/>
<!--      {{ localStorage.translations.pages['statistic_employee'].tables['images'] + ':' }}
      <BaseInput type="switch" v-model="showImages.value" class="ml-4" @input="changeImages"/>-->
    </v-card>
    <div class="horizontalScroll mb-5">
      <v-card
        tile
        flat
        width="100%"
        :min-width="minWidth"
        :max-width="maxWidth"
        class="pa-5 mx-auto"
      >
        <StatisticProjectReportsBlankTable
          :left="left"
          :right="right"
          :project-id="project?.internal_project_id"
          :confirm-page="confirmPage"
        >
          <StatisticProjectReportsBlankConfirmTableHeader
            :col-name="localStorage.translations.pages.finance['period-table'].position"
          />
          <StatisticProjectReportsBlankConfirmTableTotal
            :works="Object.values(works_total).filter((i) => i.reports.length > 0)"
            :extras="Object.values(extras_total).filter((i) => i.reports.length > 0)"
            :confirmed="confirmed"
          />
        </StatisticProjectReportsBlankTable>
      </v-card>
    </div>
    <template v-for="(employee, e) in employees">
      <div
        v-if="
          getReportsByEmployee(e, 'work_types').length > 0 ||
          getReportsByEmployee(e, 'extras').length > 0
        "
        :key="'employee' + e"
        class="horizontalScroll mb-5"
      >
        <v-card
          class="mx-auto pa-5"
          width="100%"
          :min-width="minWidth"
          :max-width="maxWidth"
          tile
          flat
        >
          <StatisticProjectReportsBlankTable
            :left="employee ? left.concat(employee.first_name + ' ' + employee.last_name) : ''"
            :right="right"
            :project-id="project?.internal_project_id"
          >
            <StatisticProjectReportsBlankConfirmTableHeader
              :col-name="localStorage.translations.pages.finance['period-table'].position"
            />
            <StatisticProjectReportsBlankConfirmTableTotal
              :works="getReportsByEmployee(e, 'work_types')"
              :extras="getReportsByEmployee(e, 'extras')"
              :confirmed="confirmed"
            />
          </StatisticProjectReportsBlankTable>
          <StatisticProjectReportsBlankTable class="mt-4">
            <StatisticProjectReportsBlankConfirmTableHeader
              :col-name="localStorage.translations.pages.finance['period-table'].date"
              :note="notes"
            >
              <BaseCheckbox
                v-model="reports.employees[e].confirmed"
                class="mr-2"
                @input="changeConfirm(e)"
              />
            </StatisticProjectReportsBlankConfirmTableHeader>
            <StatisticProjectReportsBlankConfirmTableByDays
              :data="employee"
              :confirmed="confirmed"
              :on-update-work="onUpdateWorkConfirm"
              :on-update-extra="onUpdateExtraConfirm"
              :notes="notes"
              :current-bill-id="currentBillId"
            />
          </StatisticProjectReportsBlankTable>
          <StatisticProjectReportsBlankConfirmTableImagesByDays
            v-if="images"
            class="mt-4"
            :data="employee"
            :confirmed="confirmed"
            :images="images"
            :on-change-images-count="onChangeImagesCount"
          />
        </v-card>
      </div>
    </template>
    <div class="fixedBtn">
      <v-btn
        :to="{ name: 'timeControlShowReportsViewPdf' }"
        :elevation="0"
        fab
        :width="$vuetify.breakpoint.smAndDown ? 45 : 60"
        :height="$vuetify.breakpoint.smAndDown ? 45 : 60"
        :disabled="confirmed.work_types.length === 0 && confirmed.extras.length === 0"
      >
        <icons-button icon="button-create_pdf" color="currentColor"/>
      </v-btn>
      <v-btn
        @click="changePage"
        :elevation="0"
        fab
        :width="$vuetify.breakpoint.smAndDown ? 45 : 60"
        :height="$vuetify.breakpoint.smAndDown ? 45 : 60"
      >
        <v-icon :size="$vuetify.breakpoint.smAndDown ? 25 : 35">mdi-pencil</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import StatisticProjectReportsBlankTable from '../StatisticProjectReportsBlankTable'
import StatisticProjectReportsBlankConfirmTableHeader from './StatisticProjectReportsBlankConfirmTableHeader'
import StatisticProjectReportsBlankConfirmTableTotal from './StatisticProjectReportsBlankConfirmTableTotal'
import StatisticProjectReportsBlankConfirmTableByDays
  from 'components/timeControl/reports/blank/confirm/StatisticProjectReportsBlankConfirmTableByDays'
import IconsButton from 'components/icons/button/IconsButton'
import BaseCheckbox from '../../../../base/BaseCheckbox'
import BaseInput from 'components/base/BaseInput.vue'
import StatisticProjectReportsBlankConfirmTableImagesByDays
  from "components/timeControl/reports/blank/confirm/StatisticProjectReportsBlankConfirmTableImagesByDays.vue";

export default {
  name: 'StatisticProjectReportsBlankConfirmTable',
  components: {
    StatisticProjectReportsBlankConfirmTableImagesByDays,
    BaseInput,
    BaseCheckbox,
    IconsButton,
    StatisticProjectReportsBlankConfirmTableByDays,
    StatisticProjectReportsBlankConfirmTableTotal,
    StatisticProjectReportsBlankConfirmTableHeader,
    StatisticProjectReportsBlankTable,
  },
  props: {
    project: {
      type: Object,
      default: () => {
        return {}
      },
    },
    date: {
      type: String,
      default: '',
    },
    employees: {
      type: Array,
      default: () => {
        return []
      },
    },
    currentBillId: {
      type: [Number, String],
      default: null,
    },
    onConfirmPage: {},
    confirmed: {
      type: Object,
      default: () => {
        return {
          work_types: [],
          extras: [],
        }
      },
    },
    onChangeConfirm: {},
    additional: {
      type: Array,
      default: () => {
        return []
      },
    },
    notes: Boolean,
    images: Boolean,
    onChangeNotes: {},
    onChangeImages: {},
    onChangeImagesCount: {},
    confirmPage: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    minWidth: 600,
    maxWidth: 1000,
  }),
  computed: {
    left() {
      return Array(
        this.project.name,
        this.project.street + ', ' + this.project.zip + ', ' + this.project.city,
        this.date,
      )
    },
    right() {
      return Array(
        this.project.client.name,
        (this?.project?.manager?.first_name || '-') +
        ' ' +
        (this?.project?.manager?.last_name || ''),
        this?.project?.manager?.phone,
      )
    },
    reports() {
      const isVisible = (report) => {
        if (!report) return false
        if (report.approved_report <= 0) return false
        return true
      }
      const isSelectable = (report) => {
        const isEmptyBillId = (value) => {
          return value === null || value === undefined || value === '' || value === 'null'
        }
        const isSameBillId = (value, currentBillId) => {
          if (isEmptyBillId(value) || isEmptyBillId(currentBillId)) return false
          return String(value) === String(currentBillId)
        }
        if (!report) return false
        if (report.approved_report <= 0) return false
        if (report.client_report_status === 'signed' || report.client_report_status === 'approved') return false
        if (!isEmptyBillId(report.client_bill_id) && !isSameBillId(report.client_bill_id, this.currentBillId)) return false
        return true
      }
      let temp = {}
      temp.employees = {}
      let fields = ['work_types', 'extras']
      for (let e in this.employees) {
        if (!temp.employees[e]) temp.employees[e] = {work_types: [], extras: []}
        for (let i in fields) {
          let name = fields[i]
          if (!temp[name]) temp[name] = {}
          let works = this.employees[e][name]
          for (let w in works) {
            let kk = works[w].name
            if (!temp[name][kk])
              temp[name][kk] = {
                reports: [],
                name: works[w].name,
                measure: works[w].measure,
                is_hourly: works[w].is_hourly,
                id: w,
              }
            let reports = Object.values(works[w].days).map((data) => data.reports)
            for (let r in reports) {
              for (let i in reports[r]) {
                if (isVisible(reports[r][i])) {
                  let item = reports[r][i]
                  item.employee_id = e
                  temp[name][kk].reports.push(item)
                  if (isSelectable(item)) {
                    temp.employees[e][name].push(item.id)
                  }
                }
              }
            }
          }
        }
        temp.employees[e].confirmed =
          temp.employees[e].work_types.every((cur) => {
            return this.confirmed.work_types.includes(cur)
          }) &&
          temp.employees[e].extras.every((cur) => {
            return this.confirmed.extras.includes(cur)
          })
            ? true
            : temp.employees[e].work_types.every((cur) => {
              return !this.confirmed.work_types.includes(cur)
            }) &&
            temp.employees[e].extras.every((cur) => {
              return !this.confirmed.extras.includes(cur)
            })
              ? false
              : null
      }
      return temp
    },
    showNotes() {
      return {value: this.notes}
    },
    showImages() {
      return {value: this.images}
    },
    works_total() {
      let list = Object.keys(this.reports.work_types).sort(function (a, b) {
        let nA = a.toLowerCase()
        let nB = b.toLowerCase()
        if (nA < nB) return -1
        if (nA > nB) return 1
        return 0
      })
      let temp = {}
      for (let i in list) {
        temp[list[i]] = this.reports.work_types[list[i]]
      }
      return temp
    },
    extras_total() {
      let list = Object.keys(this.reports.extras).sort(function (a, b) {
        let nA = a.toLowerCase()
        let nB = b.toLowerCase()
        if (nA < nB) return -1
        if (nA > nB) return 1
        return 0
      })
      let temp = {}
      for (let i in list) {
        temp[list[i]] = this.reports.extras[list[i]]
      }
      return temp
    },
  },
  methods: {
    changePage() {
      this.key++
      if (this.onConfirmPage) this.onConfirmPage(false)
    },
    getReportsByEmployee(employee_id, type) {
      let temp = []
      for (let t in this.reports[type]) {
        let work = this.reports[type][t]
        let item = {
          id: work.id,
          is_hourly: work.is_hourly,
          measure: work.measure,
          name: work.name,
          reports: [],
        }
        for (let r in work.reports)
          if (Number(work.reports[r].employee_id) === Number(employee_id))
            item.reports.push(work.reports[r])
        if (item.reports.length > 0) temp.push(item)
      }
      return temp
    },
    onUpdateWorkConfirm(data, value) {
      if (this.onChangeConfirm) this.onChangeConfirm('work_types', data, value)
    },
    onUpdateExtraConfirm(data, value) {
      if (this.onChangeConfirm) this.onChangeConfirm('extras', data, value)
    },
    changeNotes() {
      if (this.onChangeNotes) this.onChangeNotes()
    },
    changeImages() {
      if (this.onChangeImages) this.onChangeImages()
    },
    changeConfirm(e) {
      if (this.onChangeConfirm)
        this.onChangeConfirm(
          'work_types',
          this.reports.employees[e].work_types,
          this.reports.employees[e].confirmed,
          'extras',
          this.reports.employees[e].extras,
        )
    },
  },
}
</script>

<style scoped lang="scss">
.horizontalScroll {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    overflow-x: scroll;
    max-width: 93vw;
  }
}

:deep() .grid {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 80px 1fr;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-template-columns: 60px 1fr;
  }

  &_header {
    @extend .grid;
    grid-template-columns: 80px 150px 1fr;
    background-color: #f2f2f2;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      grid-template-columns: 60px 100px 1fr;
    }
  }

  &_inner {
    @extend .grid;
    grid-template-columns: 150px 1fr;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      grid-template-columns: 100px 1fr;
    }
  }
}
</style>
